<template>
  <div
    v-show="pdfViewerStatus"
    class="pdf-viewer"
  >
    <div
      class="pdf-viewer__overlay"
      @click="fecharModal"
    />
    <div class="pdf-viewer__modal">
      <button
        class="btn-close"
        @click="fecharModal"
      >
        <svg-loader src="/static/images/icon-close-small.svg" />
      </button>
      <iframe
        :src="pdfContent"
        width="100%"
        height="100%"
        frameborder="0"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfViewer',
  props: {
    pdfViewerStatus: {
      type: Boolean,
      required: true
    },
    pdfContent: {
      type: String,
      required: true
    }
  },
  methods: {
    fecharModal() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-viewer {
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
    z-index: 999;
  }

  &__modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    max-width: 800px;
    width: 90%;
    height: 90%;
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
  }

  .btn-close {
    position: absolute;
    top: 50px;
    right: 30px;
    background: transparent;
    color: #000;

    .md-icon {
      width: 16px;
      min-width: 16px;
    }
  }

  iframe {
    flex: 1;
    border: none;
  }
}
</style>
